module.exports = __webpack_public_path__ + "img/chrome-icon.f3b6c54c.svg";